import type { ITriggerFieldGroup, TInputMappings } from './types';
import type { IFilterCondition } from './filter-utils';

/**
 * Default empty mappings object
 */
export const DEFAULT_MAPPINGS: TInputMappings = {};

/**
 * Default empty trigger field groups
 */
export const DEFAULT_TRIGGER_FIELD_GROUPS: ITriggerFieldGroup[] = [];

/**
 * Default empty filter conditions
 */
export const DEFAULT_FILTER_CONDITIONS: IFilterCondition[] = [];
